import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { UserStateService } from 'src/app/auth/services/user-state.service';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { ScreenSharingMode } from 'src/app/screen-sharing/types/screen-sharing-mode';

@Injectable({
  providedIn: 'root',
})
export class ScreenSharingApiService extends ApiService<any> {
  protected APIUrl = environment.SCREEN_SHARING_API_URL + this.getResourceUrl();

  constructor(
    protected httpClient: HttpClient,
    private userStateService: UserStateService,
    private companyStateService: CompanyStateService,
  ) {
    super(httpClient);
  }

  override getResourceUrl(): string {
    return 'api';
  }

  private getAuthHeaders(): HttpHeaders {
    const token = this.userStateService.getAccessToken();
    if (!token?.access_token) {
      return new HttpHeaders();
    }
    return new HttpHeaders().set(
      'Authorization',
      (token.token_type || 'Bearer') + ' ' + token.access_token,
    );
  }

  getSession(sessionId: string) {
    return firstValueFrom(
      super.requestWithHeadersAsObservable(
        '',
        'GET',
        'session/' + sessionId,
        this.getAuthHeaders(),
      ),
    );
  }

  deleteSession(sessionId: string) {
    return firstValueFrom(
      super.requestWithHeadersAsObservable(
        '',
        'DELETE',
        'session/' + sessionId,
        this.getAuthHeaders(),
      ),
    );
  }

  getCompanySessions(screenSharingMode?: ScreenSharingMode) {
    let params = new HttpParams();
    if (screenSharingMode) {
      params = params.set('screenSharingMode', screenSharingMode);
    }

    return firstValueFrom(
      super.requestWithHeadersAsObservable(
        '',
        'GET',
        'sessions/company/' + this.companyStateService.getSelectedCompanyId(),
        this.getAuthHeaders(),
        params,
      ),
    );
  }
}
